module.exports = __webpack_public_path__ + "static/media/cristian.5e30e0f5.png";